import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.link.js";
import useRightPath from '~/composables/useRightPath';
export default defineComponent({
  name: 'ObfuscationLink',
  props: {
    link: String,
    isActiveObfuscatedLink: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var router = useRouter();
    var icdRef = ref(null);
    var _useRightPath = useRightPath(),
      getRouterPath = _useRightPath.getRouterPath;
    var decryptsAndUsesTheLink = function decryptsAndUsesTheLink(event) {
      var _props$link, _props$link2;
      if (!props.link) return;
      var attribute = event.currentTarget.getAttribute('data-icd');
      var dataIcd = JSON.parse(Buffer.from(attribute, 'base64').toString());
      var link = decodeURIComponent(dataIcd.path);
      var relativePath = getRouterPath(link);
      var isInternalLink = props.link.startsWith('/') || ((_props$link = props.link) === null || _props$link === void 0 ? void 0 : _props$link.startsWith('http')) && ((_props$link2 = props.link) === null || _props$link2 === void 0 ? void 0 : _props$link2.indexOf(window.location.origin)) === 0;
      if (event.ctrlKey) {
        window.open(link, '_blank');
      } else if (isInternalLink) {
        router.push(relativePath);
      } else {
        window.location.href = link;
      }
    };
    onMounted(function () {
      icdRef.value = document.querySelectorAll('.icd');
    });
    var generateDataIcd = function generateDataIcd(routePath) {
      return Buffer.from(JSON.stringify({
        path: routePath
      })).toString('base64');
    };
    return {
      icdRef: icdRef,
      decryptsAndUsesTheLink: decryptsAndUsesTheLink,
      generateDataIcd: generateDataIcd
    };
  }
});